export default __webpack_public_path__ + "static/media/mg-2-rMIN.d7fe65e6.avif";